import { useCloseOnLeave } from '@components/Dashboard/hooks/useCloseOnLeave'

import { useBooleanState } from '@/hooks'

export const useSidebarToggle = () => {
  const { setTrue, value, setFalse } = useBooleanState(false)

  useCloseOnLeave(setFalse)

  return { open: setTrue, opened: value, close: setFalse }
}
